import { ObjectModelBuiltinPropertyType } from "../../enums/objectModelBuiltinPropertyType";
import { IBaseObjectModelEntry } from "../../interfaces/objectModelInterfaces";
import UntrackedModel from "../untracked/untrackedModel";
import assertNever from '../../../global/assetNever'

export default abstract class BaseObjectModelEntry extends UntrackedModel implements IBaseObjectModelEntry {
  c_at: string;
  u_at: string;
  creator: {id: string, name: string};
  owner: {id: string, name: string, email: string}

  valueFor(clientId: string): string {
    return this[`f_${clientId}`];
  }

  displayValueFor(clientId: string): string {
    const displayKey = `f_${clientId}_display`
    if (displayKey in this){
      return this[displayKey]
    }

    return this[`f_${clientId}`];
  }

  valueForBuiltin(type: ObjectModelBuiltinPropertyType): string {
    switch (type) {
      case ObjectModelBuiltinPropertyType.CreatedAt:
        return this.c_at;
      case ObjectModelBuiltinPropertyType.CreatedBy:
        return this.creator?.name;
      case ObjectModelBuiltinPropertyType.UpdatedAt:
        return this.u_at;
      case ObjectModelBuiltinPropertyType.RecordHolderName:
        return this.owner?.name;
      case ObjectModelBuiltinPropertyType.RecordHolderEmail:
        return this.owner?.email;
      case ObjectModelBuiltinPropertyType.RecordId:
        return this.id
      default:
        assertNever(type)
    }
  }
}